import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-shell',
    templateUrl: './shell.component.html',
    styleUrls: ['./shell.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ShellComponent implements OnDestroy {

  isMobileMenuOpen = false

  private subscriptions: Subscription[] = [
    this.router.events.subscribe(event => {
      if(event instanceof NavigationStart) {
        this.isMobileMenuOpen = false
      }
    })
  ]
  constructor (
    public router: Router,
  ) { }

  ngOnDestroy (): void {
    this.subscriptions.forEach(subs => subs.unsubscribe())
  }
}
